import { faArrowRightLong } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import BreadcrumbItem from 'Components/Atoms/BreadcrumbItem/BreadcrumbItem';
import EntityIcon from 'Components/Atoms/EntityIcon/EntityIcon';
import Grid from 'Components/Atoms/Grid/Grid';
import Spinner from 'Components/Atoms/Spinner/Spinner';
import Text from 'Components/Atoms/Text/Text';
import Title from 'Components/Atoms/Title/Title';
import Breadcrumbs from 'Components/Molecules/Breadcrumbs/Breadcrumbs';
import Card from 'Components/Molecules/Card/Card';
import TitleGroup from 'Components/Molecules/TitleGroup/TitleGroup';
import SettingsTemplate from 'Components/Templates/Page/Settings/SettingsTemplate';
import { useEffect } from 'react';
import { connect } from 'react-redux';
import { Link } from 'react-router-dom';
import { ROUTES } from 'Services/Route/Route.types';
import EntityHelper from 'Services/Settings/Entity/EntityHelper';
import { StoreState } from 'Store/Reducers';
import { fetchEntities } from 'Store/Settings/Entities/Actions';
import { getEntities, isEntityLoading } from 'Store/Settings/Entities/Selectors';

const EntitiesSettingsPage = ({
    entities, isLoading,
    ...props
}: EntitiesSettingsPageProps) => {
    useEffect(() => {
        props.fetchEntities();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return <SettingsTemplate
        breadcrumbs={
            <Breadcrumbs>
                <BreadcrumbItem path={ROUTES.SETTINGS.path}>Instellingen</BreadcrumbItem>
                <BreadcrumbItem>Entiteiten</BreadcrumbItem>
            </Breadcrumbs>
        }
        description="Entiteiten instellingen"
    >
            { isLoading &&
                <Grid position='centered'>
                    <Spinner />
                    <Title size='small' weight='semibold'>Entiteiten laden...</Title>
                </Grid>
            }
            { !isLoading &&
                <Grid axis='vertical'>
                    {
                        entities.map((i: any) =>
                            <Link to={ROUTES.SETTINGS.ENTITIES.ENTITY.getFullPath(i.id)} style={{textDecoration: 'none'}} key={i.id} data-cy="entity-item">
                                <Card axis="horizontal" state="link">
                                    <TitleGroup iconBefore={
                                        <EntityIcon entity={i?.name} size='large' />
                                    }>
                                        <Title
                                            size="inherit"
                                            transform='uppercase'
                                            weight='bold'
                                        >
                                            { EntityHelper.getDisplayValueByName(i.name) }
                                        </Title>
                                        <Text color='secondary'>Ga door naar de instellingen van {EntityHelper.getDisplayValueByName(i.name)}</Text>
                                    </TitleGroup>
                                    <FontAwesomeIcon icon={faArrowRightLong} size='2x' color='#757575' />
                                </Card>
                            </Link>
                        )
                    }
                </Grid>
            }
    </SettingsTemplate>
}

interface Props {

}

const mapState = (state: StoreState) => ({
    entities: getEntities(state),
    isLoading: isEntityLoading(state)
});

const mapDispatch = {
    fetchEntities
}

type EntitiesSettingsPageProps = Props & ReturnType<typeof mapState> & typeof mapDispatch;

export default connect(mapState, mapDispatch)(EntitiesSettingsPage);